<app-q-select
  label="contact"
  [options]="contacts$ | async"
  [ngModel]="value"
  (ngModelChange)="onClick($event)"
  [disabled]="disabled"
  [invalid]="invalid"
  [inline]="inline"
></app-q-select>
